up.compiler('.slide-notification', (element) => {

  function updateHidden() {
    const hasContent = /\S/.test(element.textContent)
    element.toggleAttribute('hidden', !hasContent)
  }

  const observer = new MutationObserver(updateHidden)
  observer.observe(element, {
    characterData: true,
    childList: true,
    subtree: true,
  })

  updateHidden()

  return function onDestroy() {
    observer.disconnect()
  }

})
